"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _globalStyles = require("../global-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColWidth = function ColWidth(span) {
  var ColCount = 12;
  var ColumnWidth = span / ColCount * 100;
  return ColumnWidth;
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Column__Wrapper",
  componentId: "sc-ty1h6o-0"
})(["position:relative;width:100%;padding:0 ", ";overflow:auto;flex-basis:0;flex-grow:1;max-width:100%;align-items:", ";justify-content:", ";@media ", "{flex:0 0 ", "%;}@media ", "{flex:", ";}@media ", "{flex:", ";}@media ", "{flex:", ";}&:first-of-type{padding-left:10px;}&:last-of-type{padding-right:10px;}"], function (props) {
  return props.paddingY ? props.paddingY : '10px';
}, function (props) {
  return props.alignItems ? props.alignItems : null;
}, function (props) {
  return props.justifyContent ? props.justifyContent : null;
}, _globalStyles.Screen.sm, function (props) {
  return props.sm ? ColWidth(props.sm) : '100';
}, _globalStyles.Screen.md, function (props) {
  return props.md ? "0 0 ".concat(ColWidth(props.md), "%") : null;
}, _globalStyles.Screen.mdUp, function (props) {
  return props.mdUp ? "0 0 ".concat(ColWidth(props.mdUp), "%") : null;
}, _globalStyles.Screen.lg, function (props) {
  return props.lg ? "0 0 ".concat(ColWidth(props.lg), "%") : null;
});

var Column = function Column(_ref) {
  var className = _ref.className,
      children = _ref.children,
      span = _ref.span,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      sm = _ref.sm,
      md = _ref.md,
      mdUp = _ref.mdUp,
      lg = _ref.lg,
      paddingY = _ref.paddingY;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className,
    span: span,
    alignItems: alignItems,
    justifyContent: justifyContent,
    sm: sm,
    md: md,
    mdUp: mdUp,
    lg: lg,
    paddingY: paddingY
  }, children);
};

var _default = Column;
exports.default = _default;